<template>
  <v-layout
    align-center
    wrap
  >
    <template v-for="(member, index) in members">
      <v-flex
        v-if="selected.includes(member.id)"
        :key="index"
        xs12
        class="mb-3"
        :class="[{ 'personal-form personal-form_bordered': member.complete }]"
      >
        <v-layout>
          <v-flex
            class="mt-4 mr-2"
            :shrink="lgAndUp"
          >
            <span class="fw-600 f-2 text-dark">{{ indexNum(index) }}</span>
          </v-flex>
          <v-flex>
            <v-layout wrap>
              <v-flex
                v-if="getExpensesForMedicineQuestions.members.hasOwnProperty('name')"
                lg3
                md12
                :class="[{ 'pr-3': $vuetify.breakpoint.mdAndUp }]"
              >
                <v-text-field
                  :label="getExpensesForMedicineQuestions.members.name.label"
                  :disabled="readOnly"
                  :value="member.name"
                  class="personal-input_disabled"
                />
              </v-flex>
              <v-flex
                v-if="getExpensesForMedicineQuestions.members.hasOwnProperty('illness')"
                lg4
                md12
                :class="[{ 'px-3': $vuetify.breakpoint.lgAndUp }]"
              >
                <v-text-field
                  v-model.trim="member.illness"
                  v-validate="{
                    ...regularLongText(
                      getExpensesForMedicineQuestions.members.illness.required,
                      180
                    )
                  }"
                  :label="getExpensesForMedicineQuestions.members.illness.label"
                  :disabled="readOnly"
                  :error-messages="errors.collect(createDataName('disease', member.id))"
                  :data-vv-as="$t('label.disease')"
                  :data-vv-name="createDataName('disease', member.id)"
                  :required="getExpensesForMedicineQuestions.members.illness.required"
                  @blur="completePersonData(member.id)"
                  @focus="falseComplete(member.complete)"
                />
              </v-flex>
              <v-flex
                v-if="
                  getExpensesForMedicineQuestions.members.hasOwnProperty('degree_of_disability')
                "
                lg4
                md12
                :class="[{ 'px-3': $vuetify.breakpoint.lgAndUp }]"
              >
                <v-text-field
                  v-model.trim="member.degreeOfDisability"
                  v-validate="{
                    ...regularLongText(
                      getExpensesForMedicineQuestions.members.degree_of_disability.required,
                      180
                    )
                  }"
                  :label="getExpensesForMedicineQuestions.members.degree_of_disability.label"
                  :disabled="readOnly"
                  :error-messages="
                    errors.collect(createDataName('degree_of_disability', member.id))
                  "
                  :data-vv-as="$t('label.disease')"
                  :data-vv-name="createDataName('degree_of_disability', member.id)"
                  :required="getExpensesForMedicineQuestions.members.degree_of_disability.required"
                  @blur="completePersonData(member.id)"
                  @focus="falseComplete(member.complete)"
                />
              </v-flex>
              <v-flex
                v-if="getExpensesForMedicineQuestions.members.hasOwnProperty('disability_origin')"
                lg4
                md12
                class="offset-lg3"
                :class="[{ 'px-3': $vuetify.breakpoint.lgAndUp }]"
              >
                <v-text-field
                  v-model.trim="member.disabilityOrigin"
                  v-validate="{
                    ...regularLongText(
                      getExpensesForMedicineQuestions.members.disability_origin.required,
                      180
                    )
                  }"
                  :label="getExpensesForMedicineQuestions.members.disability_origin.label"
                  :disabled="readOnly"
                  :error-messages="errors.collect(createDataName('disability_origin', member.id))"
                  :data-vv-as="$t('label.disease')"
                  :data-vv-name="createDataName('disability_origin', member.id)"
                  :required="getExpensesForMedicineQuestions.members.disability_origin.required"
                  @blur="completePersonData(member.id)"
                  @focus="falseComplete(member.complete)"
                />
              </v-flex>

              <v-flex
                v-if="
                  getExpensesForMedicineQuestions.members.hasOwnProperty(
                    'monthly_cost_of_treatment'
                  )
                "
                lg5
                md12
                :class="[{ 'px-3': $vuetify.breakpoint.lgAndUp }]"
              >
                <v-text-field
                  v-model="member.monthlyCostOfTreatment"
                  v-validate="{
                    ...requiredMoney(
                      getExpensesForMedicineQuestions.members.monthly_cost_of_treatment.required
                    )
                  }"
                  :disabled="readOnly"
                  :label="getExpensesForMedicineQuestions.members.monthly_cost_of_treatment.label"
                  :suffix="$t('label.amount_suffix')"
                  :error-messages="
                    errors.collect(createDataName('monthly_cost_of_treatment', member.id))
                  "
                  :data-vv-as="$t('label.amount_on_medicine')"
                  :data-vv-name="createDataName('monthly_cost_of_treatment', member.id)"
                  inputmode="decimal"
                  @keyup="countFromMembers()"
                  @blur="completePersonData(member.id)"
                  @focus="falseComplete(member.complete)"
                />
              </v-flex>
              <v-flex
                v-if="getExpensesForMedicineQuestions.members.hasOwnProperty('note')"
                xs12
                class="mt-3"
              >
                <v-textarea
                  v-model="member.note"
                  v-validate="{
                    ...regularLongText(getExpensesForMedicineQuestions.members.note.required, 180)
                  }"
                  :disabled="readOnly"
                  :label="getExpensesForMedicineQuestions.members.note.label"
                  :error-messages="errors.collect(createDataName('regular_field', member.id))"
                  :data-vv-as="$t('label.question')"
                  :data-vv-name="createDataName('regular_field', member.id)"
                  :placeholder="member.complete ? '-' : $t('sheet.enter_text')"
                  class="small"
                  @blur="completePersonData(member.id)"
                  @focus="falseComplete(member.complete)"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider
          v-if="index < members.length - 1"
          class="mt-3"
        />
      </v-flex>
    </template>
    <v-flex xs12>
      <v-layout
        class="pa-4 grey-fill"
        wrap
      >
        <v-flex xs12>
          <p class="f-2 fw-600 text-xs-right text-dark mb-2">
            {{ getExpensesForMedicineQuestions.total_medicine_amount.label }}
          </p>
        </v-flex>
        <v-flex xs12>
          <p class="f-28 fw-600 mb-0 text-xs-right text-dark">
            {{ totalAmount | currency }}
          </p>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';
import filters from '@/constants/filters';

import { createHelpers } from 'vuex-map-fields';
import { mapGetters } from 'vuex';

const { mapFields } = createHelpers({
    getterType: 'sheet/getExpensesForMedicineField',
    mutationType: 'sheet/updateExpensesForMedicineField'
});

export default {
    name: 'IllMembersFrom',
    filters: {
        ...filters
    },
    mixins: [sheetValidationRules],
    inject: ['$validator'],
    props: {
        members: {
            type: Array,
            default: () => {
                return [
                    {
                        monthlyCostOfTreatment: 0
                    }
                ];
            }
        },
        selected: {
            type: Array,
            default: () => {
                return [];
            }
        },
        readOnly: {
            default: false
        }
    },
    data () {
        return {
            totalAmount: 0,
            membersLabels: []
        };
    },
    computed: {
        ...mapFields(['totalMedicineAmount']),
        ...mapGetters('sheet', ['getExpensesForMedicineQuestions']),
        lgAndUp () {
            return this.$vuetify.breakpoint.lgAndUp;
        }
    },
    watch: {
        totalAmount: {
            immediate: true,
            handler (val) {
                if (val == null) {
                    this.totalMedicineAmount = null;
                } else {
                    this.totalMedicineAmount = parseFloat(val.toFixed(2));
                }
            }
        },
        members: {
            handler () {
                this.countFromMembers();
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        indexNum (index) {
            return index + 1 + '.';
        },
        createDataName (name, id) {
            return name + id;
        },
        countFromMembers () {
            this.totalAmount = 0;
            this.members.forEach((el) => {
                let _num;
                if (
                    typeof el.monthlyCostOfTreatment === 'string' &&
          el.monthlyCostOfTreatment.indexOf(',') !== -1
                ) {
                    _num = Number(el.monthlyCostOfTreatment.replace(',', '.'));
                } else {
                    _num = Number(el.monthlyCostOfTreatment);
                }
                if (!isNaN(_num)) {
                    this.totalAmount += parseFloat(_num.toFixed(2));
                }
            });
        },
        completePersonData (id) {
            this.members.forEach((el) => {
                if (el.id === id) {
                    const _keys = [];
                    Object.keys(this.fields).forEach((key) => {
                        if (key.indexOf(id) !== -1) {
                            _keys.push(this.fields[key]);
                        }
                    });
                    el.complete = Object.keys(_keys).every((key) => _keys[key].valid);
                }
            });
        },
        falseComplete (el) {
            el = false;
        }
    }
};
</script>

<style scoped></style>
